import { render, staticRenderFns } from "./VModalAttachFilesFile.vue?vue&type=template&id=7527daa9&"
import script from "./VModalAttachFilesFile.vue?vue&type=script&lang=ts&"
export * from "./VModalAttachFilesFile.vue?vue&type=script&lang=ts&"
import style0 from "./VModalAttachFilesFile.vue?vue&type=style&index=0&id=7527daa9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports